<section class="section-inset-y">
  <div class="container">
    <h1 class="h3">Icons</h1>

    <span class="text-muted mb-2 d-inline-block">Icon sizes</span>
    <ul class="d-flex mb-4 align-items-end">
      @for (size of sizes; track size) {
        <li class="me-4 d-flex flex-column align-items-center">
          <app-icon [ngClass]="'icon-' + size" [anchor]="'icon-instagram'"></app-icon>
          <span class="text-muted d-inline-block">icon-{{ size }}</span>
        </li>
      }
    </ul>

    <span class="text-muted mb-2 d-inline-block">All icons</span>
    <ul class="icon-list row">
      @for (icon of icons; track icon) {
        <li class="icon-list__item col-md-3">
          <app-icon [anchor]="icon"></app-icon>
          <span class="text-muted ms-3 d-inline-block">{{ icon }}</span>
        </li>
      }
    </ul>
  </div>
</section>
